import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  inject,
  input,
  model,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { directusAuthInstance } from '../../libs/directus';
import { deleteFile, updateItem, uploadFiles } from '@directus/sdk';
import { DirectusFileSchema } from '../../schemas/business';
import { environment } from '../../../../environments/environment';
import { RequestsService } from '../../utils/services/requests.service';
import { HandleErrorsService } from '../../utils/services/handle-errors.service';

@Component({
  selector: 'qwiko-image-uploader',
  imports: [CommonModule, FormsModule],
  templateUrl: './image-uploader.component.html',
  styleUrl: './image-uploader.component.scss',
})
export class ImageUploaderComponent {
  private requestsService = inject(RequestsService);
  private handleErrorsService = inject(HandleErrorsService);
  env = environment;
  directusClient = directusAuthInstance;
  loading = signal<boolean>(false);
  updateItem = input.required<boolean>();
  currentFile = model<DirectusFileSchema | null>(null);
  disabled = model.required<boolean>();
  currentFileLink = computed<string>(() => {
    return this.currentFile() !== null
      ? `${this.env.apiUrl}/assets/${this.currentFile()!.id}/${this.currentFile()!.filename_disk}`
      : '';
  });
  contextCollection = input<string | null>(null);
  contextID = input<string | null>(null);
  contextFieldName = input<string | null>(null);
  file = output<any>();
  fileResult = signal<DirectusFileSchema | null>(null);

  localImageLink = signal<string | null>(null);

  async onFileSelected(event: Event) {
    this.loading.set(true);
    const input = event.target as HTMLInputElement;
    const formData = new FormData();
    const file = input.files?.[0];
    if (file) {
      formData.append('file', file, file.name);
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.localImageLink.set(e.target.result);
      };
      reader.readAsDataURL(file);
    }
    await this.deleteFile();
    try {
      const result = await this.requestsService.handleRequest(() =>
        this.directusClient.request(uploadFiles(formData)),
      );
      this.fileResult.set(result as DirectusFileSchema);
      this.file.emit(result);
      if (this.updateItem()) {
        await this.updateFileInItem();
      }
    } catch (error) {
      this.handleErrorsService.handleErrors(error);
    }
    // console.log('DELETED FILE', this.currentFile());
    this.loading.set(false);
  }

  async deleteFile() {
    if (this.currentFile()) {
      try {
        const deleteResponse = await this.requestsService.handleRequest(() =>
          this.directusClient.request(deleteFile(this.currentFile()!.id!)),
        );
        this.currentFile.set(null);
        return deleteResponse;
      } catch (error) {
        this.handleErrorsService.handleErrors(error);
      }
    }
  }

  async updateFileInItem() {
    const data = {
      [this.contextFieldName()!]: this.fileResult()!.id,
    };

    try {
      const itemResponse = await this.requestsService.handleRequest(() =>
        this.directusClient.request(
          updateItem(this.contextCollection()!, this.contextID()!, data),
        ),
      );
      return itemResponse;
    } catch (error) {
      this.handleErrorsService.handleErrors(error);
      this.loading.set(false);
    }
  }
}
